import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=bb50a5e4&scoped=true&"
import script from "./AppHeader.vue?vue&type=script&lang=js&"
export * from "./AppHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=bb50a5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb50a5e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb50a5e4')) {
      api.createRecord('bb50a5e4', component.options)
    } else {
      api.reload('bb50a5e4', component.options)
    }
    module.hot.accept("./AppHeader.vue?vue&type=template&id=bb50a5e4&scoped=true&", function () {
      api.rerender('bb50a5e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppHeader.vue"
export default component.exports